import { useState, useRef } from 'react'
import Link from 'next/link'
import Image from 'next/image'

import GalleryArrow from '~/components/icons/IconGalleryArrow'

export default function ArticleList({ posts }) {
  const [imageGalleryPosition, setImageGalleryPosition] = useState(0)
  const imageGallerySectionRef = useRef(null)
  const imageGalleryContainerRef = useRef(null)
  const hideArrows = posts.length > 2 ? false : true

  const handleGalleryScroll = (direction: 'left' | 'right') => {
    const multiplier = direction === 'left' ? -1 : 1
    const imageGallerySectionWidth = imageGallerySectionRef.current.offsetWidth
    const imageGalleryContainerRefWidth =
      imageGalleryContainerRef.current.offsetWidth
    var scrollPosition =
      imageGalleryPosition + (imageGallerySectionWidth / 3) * multiplier
    if (scrollPosition > imageGalleryContainerRefWidth * 1.5) {
      scrollPosition = imageGalleryContainerRefWidth * 1.5
    } else if (scrollPosition < 0) {
      scrollPosition = 0
    }
    setImageGalleryPosition(scrollPosition)
    document
      .querySelector('#imageGallery')
      .scrollTo({ left: scrollPosition, behavior: 'smooth' })
  }

  return (
    <div ref={imageGallerySectionRef} className="relative">
      <div
        className={`absolute left-0 top-1/3 transform -translate-y-1/3 z-20 xl:-ml-8 cursor-pointer pl-4 xl:pl-0 ${
          hideArrows ? 'hidden' : ' hidden lg:block'
        }`}
        onClick={() => handleGalleryScroll('left')}
      >
        <GalleryArrow direction="left" />
      </div>
      <div
        className={`absolute right-0 top-1/3 transform -translate-y-1/3 z-20 xl:-mr-8 cursor-pointer pr-4 xl:pr-4 ${
          hideArrows ? 'hidden' : ' hidden lg:block'
        }`}
        onClick={() => handleGalleryScroll('right')}
      >
        <GalleryArrow direction="right" />
      </div>
      <div
        id="imageGallery"
        ref={imageGalleryContainerRef}
        className="article-posts flex flex-row overflow-x-scroll -mx-6 pl-6"
      >
        {posts.map((post, index) => {
          let previewImage =
            post.featuredImageURL ||
            'https://mary-ag.nyc3.cdn.digitaloceanspaces.com/assets/article-feature-example.png'

          return (
            <Link href={`/articles/${post.slug}`} key={index + post.title}>
              <a
                className={`w-4/5 lg:w-2/5 flex flex-col flex-grow-0 flex-shrink-0 ${
                  index > 0 ? 'ml-6' : ''
                } cursor-pointer`}
              >
                <div>
                  <Image
                    src={previewImage}
                    alt={`MaryAG ${post.title}`}
                    width={488}
                    height={366}
                    layout="responsive"
                    objectFit="cover"
                    className="aspect-w-13 aspect-h-10"
                  />
                </div>
                <div>
                  {post.title && (
                    <p className="text-white text-[1.25rem] lg:text-lg pt-6 lg:pt-8">
                      {post.title}
                    </p>
                  )}
                  <div className="flex flex-row items-center pt-4">
                    <div className="flex flex-col">
                      {post.authorName && (
                        <span className="text-white">{post.authorName}</span>
                      )}
                      {post.publishedAt && (
                        <span className="text-white opacity-70">
                          {post.publishedAt}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </a>
            </Link>
          )
        })}
      </div>
      <style jsx>{`
        .article-posts {
          scrollbar-width: none;
          scrollbar-color: #030303;
        }
        .article-posts::-webkit-scrollbar {
          display: none;
          width: 0px;
        }
        .article-posts::-webkit-scrollbar-track {
          background: #030303;
        }
        .article-posts::-webkit-scrollbar-thumb {
          background: #030303;
        }
      `}</style>
    </div>
  )
}
